import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_USERS,
    GET_RAW_JOBPACKS,
    SET_ACTIVE_JOBPACK,
    SET_CLICKED_EVENT_SEGMENT,
    SET_JOBPACK_DATES,
    SET_ARRANGED_JOBPACKS,
    GET_ROSTER_IS_LOCKED,
    SET_SELECTED_JOBPACK_ID
} from "./types";
import moment from "moment";

const INITIAL_STATE = {
    weekCount: 1,
    weekStart: moment()
        .startOf("isoWeek")
        .toDate(),
    users: false,
    usersRequesting: false,
    rawJobpacks: false,
    rawJobpacksRequesting: false,
    activeJobpack: false,
    clickedEventSegment: false,
    arrangedJobpacks: false,
    selectedJobpackID: false,
    isLocked: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SELECTED_JOBPACK_ID: {
            return {
                ...state,
                selectedJobpackID: action.payload
            };
        }
        case SET_ARRANGED_JOBPACKS: {
            return {
                ...state,
                arrangedJobpacks: { ...action.payload }
            };
        }
        case SET_JOBPACK_DATES: {
            return {
                ...state,
                jobpacks: { ...action.payload }
            };
        }
        case SET_CLICKED_EVENT_SEGMENT: {
            return {
                ...state,
                clickedEventSegment: action.payload
            };
        }
        case SET_ACTIVE_JOBPACK: {
            return {
                ...state,
                activeJobpack: action.payload
            };
        }
        case SET_WEEK_COUNT: {
            return { ...state, weekCount: action.payload };
        }
        case SET_WEEK_START: {
            return { ...state, weekStart: action.payload };
        }
        case GET_RAW_JOBPACKS.REQUEST: {
            return { ...state, rawJobpacksRequesting: true };
        }
        case GET_RAW_JOBPACKS.FAIL: {
            return {
                ...state,
                rawJobpacks: false,
                rawJobpacksRequesting: false
            };
        }
        case GET_RAW_JOBPACKS.SUCCESS: {
            return {
                ...state,
                rawJobpacks: action.payload,
                rawJobpacksRequesting: false
            };
        }
        case GET_USERS.REQUEST: {
            return { ...state, usersRequesting: true };
        }
        case GET_USERS.FAIL: {
            return { ...state, users: false, usersRequesting: false };
        }
        case GET_USERS.SUCCESS: {
            return {
                ...state,
                users: action.payload,
                usersRequesting: false
            };
        }
        case GET_ROSTER_IS_LOCKED.REQUEST: {
            return { ...state, isLockedRequesting: true };
        }
        case GET_ROSTER_IS_LOCKED.FAIL: {
            return { ...state, isLocked: false, isLockedRequesting: false };
        }
        case GET_ROSTER_IS_LOCKED.SUCCESS: {
            return {
                ...state,
                isLocked: action.payload,
                isLockedRequesting: false
            };
        }
        default: {
            return state;
        }
    }
};
